import { encryptData,decryptData } from "./securityService"

let base = "/api"
if(process.env.REACT_APP_API_URL){
  base = process.env.REACT_APP_API_URL
}
const frontKey = localStorage.getItem('frontKey')

async function post(url:any,key:string|null,data:any={}){
  data.origin = globalThis.location.protocol + '//' + globalThis.location.host + globalThis.location.pathname
  const bodyData = key ? await encryptData(data,key) : {data:{origin:data.origin},key: frontKey}
  const config:RequestInit = {
    method: 'POST',
    body: JSON.stringify(bodyData),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    }
  }
  const res = await fetch(base + url,config)
  const encryptedData = await res.json();
  if(!encryptedData.key){
    return encryptedData
  }
  return decryptData(encryptedData)
}

const fetchDataService = {post}
export default fetchDataService